// This is being used for the report form in the datalab reports index page
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["reportType", "anchorType"]
  
  // Store all original options when controller connects
  originalOptions = []

  connect() {
    // Save all original options on connect
    this.originalOptions = this.getAllOptions()
    this.updateAnchorOptions()
  }

  getAllOptions() {
    return Array.from(this.anchorTypeTarget.options)
      .map(option => {
        return {
          value: option.value,
          text: option.text,
          selected: option.selected
        }
      })
      .filter(option => option.value !== "")
  }

  updateAnchorOptions() {
    const reportType = this.reportTypeTarget.value
    const anchorSelect = this.anchorTypeTarget
    
    // Clear all options except the blank one
    while (anchorSelect.options.length > 1) {
      anchorSelect.remove(1)
    }
    
    if (reportType === "detail") {
      // For "detail" report type, show all original options
      this.originalOptions.forEach(option => {
        const newOption = new Option(option.text, option.value, option.selected, option.selected)
        anchorSelect.add(newOption)
      })
    } else if (reportType !== "") {
      // For any other report type, only show "hours" option
      const hoursOption = this.originalOptions.find(option => option.value === "hours")
      if (hoursOption) {
        const newOption = new Option(hoursOption.text, hoursOption.value, true, true)
        anchorSelect.add(newOption)
      }
    }
  }
}
